import { gql } from '@apollo/client'

const CUISINE_TYPE_QUERY = gql`
  query cuisineType($id: ID!) {
    cuisineType(id: $id) {
      id
      name
      description
      synonyms
      position
      maxPosition
      imageUrl
      updatedAt
      updatedBy {
        id
        name
      }
      node {
        id
        name
        isCurationEnabled
        level
        idPath
        namePath
      }
      isErrorProne
      isExcludedFromSearch
      isExcludedFromBrowsing
    }
  }
`

export default CUISINE_TYPE_QUERY
